import { isPlatformBrowser } from '@angular/common';
import { Directive, ElementRef, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';

@Directive({
  selector: '[clientSideOnly]'
})
export class ClientSideOnlyDirective {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    @Inject(PLATFORM_ID) private platformId: object
  ) {
    if (this.el?.nativeElement && !isPlatformBrowser(this.platformId)) {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    }
  }
}
